(function () {
  var OFF_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none"><path d="M9.19374 1.27441C8.37565 1.27937 6.80392 1.7256 5.49994 1.7256H5.48506C4.15133 1.7256 2.64407 1.27441 1.79127 1.27441C1.32521 1.27441 0.938477 1.56198 0.938477 1.89914C0.943435 2.5189 1.52353 2.56848 1.52353 5.15166C1.52849 7.72988 0.948393 7.70013 0.948393 8.31493C0.948393 8.67192 1.33017 8.93966 1.80119 8.93966C2.65398 8.93966 4.51823 8.55788 5.51481 8.55788C6.50148 8.55788 8.37565 8.92974 9.19374 8.92974C9.63501 8.92974 10.0515 8.662 10.0515 8.30998C10.0515 7.69021 9.50113 7.72492 9.50113 5.1467C9.50113 2.54865 10.0515 2.51394 10.0515 1.88922C10.0515 1.55703 9.64492 1.27441 9.19374 1.27441Z" stroke="#2D2D2D" stroke-opacity="0.2" stroke-miterlimit="10"/></svg>';
  var ON_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none"><path d="M5.39838 1.7256C6.70236 1.7256 8.27408 1.27937 9.09217 1.27441C9.54336 1.27441 9.94992 1.55703 9.94992 1.88922C9.94992 2.51394 9.39957 2.54865 9.39957 5.1467C9.39957 7.72492 9.94992 7.69021 9.94992 8.30998C9.94992 8.662 9.53344 8.92974 9.09217 8.92974C8.27408 8.92974 6.39992 8.55788 5.41325 8.55788C4.41667 8.55788 2.55242 8.93966 1.69963 8.93966C1.2286 8.93966 0.84683 8.67192 0.84683 8.31493C0.84683 7.70013 1.42693 7.72988 1.42197 5.15166C1.42197 2.56848 0.841872 2.5189 0.836914 1.89914C0.836914 1.56198 1.22365 1.27441 1.68971 1.27441C2.5425 1.27441 4.04977 1.7256 5.3835 1.7256" fill="#5F8541"/><path d="M5.39838 1.7256C6.70236 1.7256 8.27408 1.27937 9.09217 1.27441C9.54336 1.27441 9.94992 1.55703 9.94992 1.88922C9.94992 2.51394 9.39957 2.54865 9.39957 5.1467C9.39957 7.72492 9.94992 7.69021 9.94992 8.30998C9.94992 8.662 9.53344 8.92974 9.09217 8.92974C8.27408 8.92974 6.39992 8.55788 5.41325 8.55788C4.41667 8.55788 2.55242 8.93966 1.69963 8.93966C1.2286 8.93966 0.84683 8.67192 0.84683 8.31493C0.84683 7.70013 1.42693 7.72988 1.42197 5.15166C1.42197 2.56848 0.841872 2.5189 0.836914 1.89914C0.836914 1.56198 1.22365 1.27441 1.68971 1.27441C2.5425 1.27441 4.04977 1.7256 5.3835 1.7256H5.39838Z" stroke="#5F8541" stroke-miterlimit="10"/></svg>';

  function initGalleryDots(gallery) {
    var viewer = gallery.querySelector('slider-component[id^="GalleryViewer"]');
    var dotsContainer = gallery.querySelector('.c-media-dots');
    if (!viewer || !dotsContainer || dotsContainer.dataset.dotsReady) return;

    var slider = viewer.querySelector('[id^="Slider-"]');
    if (!slider) return;

    function getSlides() {
      return Array.prototype.slice.call(viewer.querySelectorAll('.product__media-item'));
    }

    function currentIndex() {
      var width = slider.clientWidth || 1;
      return Math.round(slider.scrollLeft / width);
    }

    function setActive(index) {
      var dots = dotsContainer.children;
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === index);
      }
    }

    function build() {
      var slides = getSlides();
      dotsContainer.innerHTML = '';
      slides.forEach(function (slide, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'c-media-dot';
        dot.setAttribute('aria-label', i + 1 + '枚目の画像へ');
        dot.innerHTML =
          '<span class="c-media-dot__off">' + OFF_SVG + '</span>' +
          '<span class="c-media-dot__on">' + ON_SVG + '</span>';
        dot.addEventListener('click', function () {
          slider.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        });
        dotsContainer.appendChild(dot);
      });
      setActive(currentIndex());
    }

    build();
    dotsContainer.dataset.dotsReady = 'true';

    viewer.addEventListener('slideChanged', function (event) {
      var index =
        event.detail && event.detail.currentPage ? event.detail.currentPage - 1 : currentIndex();
      setActive(index);
    });

    var scrollTimer = null;
    slider.addEventListener('scroll', function () {
      if (scrollTimer) return;
      scrollTimer = window.requestAnimationFrame(function () {
        scrollTimer = null;
        setActive(currentIndex());
      });
    });
  }

  function initAll() {
    document.querySelectorAll('media-gallery').forEach(initGalleryDots);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
